import React, { ReactElement } from 'react'

interface OuterLayoutProps {
    children: ReactElement /** expects InnerLayout partial */
    outerChildren?: ReactElement[]
}
export const OuterLayoutRSC = ({ children, outerChildren }: OuterLayoutProps): JSX.Element => {
    return (
        <div className="o-layout__outer">
            <>
                {outerChildren && outerChildren}
                {children}
            </>
        </div>
    )
}
